<template lang="pug">
.event-list
  .title(@click="showDay = !showDay" :aria-label="__('Toggle Content', eventNamespace)")
    h2 {{ __(eventDay, 'auto') }}{{ timeZoneLabel ? ` (${timeZoneLabel})` : '' }}
    Icon.toggle(:name="showDay ? 'arrow-up' : 'arrow-down'" fill="black")
  .row-table(v-show="showDay")
    EventDetails(v-for="(event, index) in events" :key="index" :event="event")
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { eventNamespace } from '../../js/constants'
import EventDetails from './EventDetails.vue'

const showDay = ref(true)

const props = withDefaults(defineProps<{
  eventDay?: string
  events?: any[]
  expanded?: boolean
  timeZoneLabel?: string
}>(), {
  eventDay      : '',
  events        : () => [],
  expanded      : true,
  timeZoneLabel : '',
})

showDay.value = props.expanded

</script>
<style lang="scss" scoped>
.event-list {
  margin-bottom: $size-xxl;

  .title {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: $size-l;
    cursor: pointer;
    border-bottom: 1px $color-gray-light solid;
    padding-bottom: $space-s;

    h2 {
      margin-bottom: 0;
      margin-right: $space-s;
      font-size: $size-l;
    }

    span {
      font-size: $size-xs;
    }
  }

  .toggle {
    position: absolute;
    right: 0;
    height: $size-s;
    width: $size-s;
  }
}

</style>
